module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-vehicle-selector"
  }, [_c('el-input', {
    attrs: {
      "readonly": "",
      "placeholder": _vm.placeholder || '请选择规格型号',
      "disabled": _vm.disabled
    },
    on: {
      "focus": _vm.showVehicleDialog
    },
    model: {
      value: (_vm.vehicleValue),
      callback: function($$v) {
        _vm.vehicleValue = $$v
      },
      expression: "vehicleValue"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-search",
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.showVehicleDialog
    },
    slot: "suffix"
  })]), _vm._v(" "), _c('rt-vehicle-dialog', {
    ref: "vehicleDialog",
    attrs: {
      "data-source": _vm.dataSource,
      "display-fields": _vm.displayFields
    },
    on: {
      "vehicle-selected": _vm.handleVehicleSelected
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40092e69"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/vehicle-selector/src/vehicle-selector.vue
// module id = 1420
// module chunks = 116